var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dl9t6wdnla)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9.75V8.5a.241.241 0 0 0-.25-.25H7v-4A.241.241 0 0 0 6.75 4h-2.5a.24.24 0 0 0-.25.25V5.5a.241.241 0 0 0 .25.25H5v2.5h-.75A.24.24 0 0 0 4 8.5v1.25a.241.241 0 0 0 .25.25h3.5A.24.24 0 0 0 8 9.75zm-1-7V1.5a.241.241 0 0 0-.25-.25h-1.5A.24.24 0 0 0 5 1.5v1.25a.241.241 0 0 0 .25.25h1.5A.241.241 0 0 0 7 2.75zM12 6a5.87 5.87 0 0 1-.8 3.012 5.972 5.972 0 0 1-2.184 2.184 6.038 6.038 0 0 1-6.023 0A5.973 5.973 0 0 1 .809 9.012a6.038 6.038 0 0 1 0-6.023A5.973 5.973 0 0 1 2.993.805a6.038 6.038 0 0 1 6.023 0A5.973 5.973 0 0 1 11.2 2.99 5.87 5.87 0 0 1 12 6z",
    fill: "url(#i46sd0cbmb)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "i46sd0cbmb",
    x1: 6.002,
    y1: 0,
    x2: 6.002,
    y2: 12.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45D9B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008DA9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dl9t6wdnla"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo1);
export default __webpack_public_path__ + "static/media/info-1.e65bf93e003044dd12b83adfde1ce52b.svg";
export { ForwardRef as ReactComponent };